export default __webpack_public_path__ + "static/automotiveMotor-6e04dcadf2b75200432cb36cc32a9bb8.jpeg";